<template>
	<section>
		<loader :dialog="loaderDialog"></loader>
		<floating-alert :message="alertMessage" :show="alertShow" :type="alertType"></floating-alert>

		<v-card elevation="2" rounded="xl">
			<div class="salle-header">
				<div class="salle-header-left">
					<div class="salle-icon-box">
						<v-icon size="18" color="white">mdi-domain</v-icon>
					</div>
					<div>
						<p class="salle-title">Gestion des salles</p>
						<p class="salle-subtitle">Configuration multi-sites</p>
					</div>
				</div>

				<v-spacer></v-spacer>

				<v-dialog v-if="isAdmin" v-model="dialog" max-width="480px">
					<template v-slot:activator="{ on, attrs }">
						<v-btn depressed rounded class="salle-add-btn" v-bind="attrs" v-on="on">
							<v-icon left small>mdi-plus</v-icon>
							Nouvelle salle
						</v-btn>
					</template>
					<v-card rounded="xl" class="pa-2">
						<div class="form-dialog-header">
							<div class="form-dialog-icon" style="background:#c62828;">
								<v-icon size="14" color="white">mdi-domain</v-icon>
							</div>
							<div>
								<p class="form-dialog-title">{{ formTitle }}</p>
								<p class="form-dialog-sub">Salle de sport</p>
							</div>
							<v-spacer></v-spacer>
							<v-btn icon small @click="closeDialog"><v-icon color="#6b7280">mdi-close</v-icon></v-btn>
						</div>
						<v-divider></v-divider>
						<v-card-text class="pt-5">
							<v-form ref="form" v-model="valid" lazy-validation>
								<v-text-field
									v-model="form.name"
									label="Nom de la salle"
									outlined dense rounded
									prepend-inner-icon="mdi-domain"
									:rules="[v => !!v || 'Champ requis']"
									hide-details="auto" class="mb-4"
								></v-text-field>
								<v-text-field
									v-model="form.address"
									label="Adresse"
									outlined dense rounded
									prepend-inner-icon="mdi-map-marker"
									:rules="[v => !!v || 'Champ requis']"
									hide-details="auto" class="mb-4"
								></v-text-field>
								<v-text-field
									v-model="form.phone"
									label="Téléphone (optionnel)"
									outlined dense rounded
									prepend-inner-icon="mdi-phone"
									hide-details
								></v-text-field>
							</v-form>
						</v-card-text>
						<v-card-actions class="pa-4 pt-2">
							<v-btn text rounded color="grey darken-1" @click="closeDialog">Annuler</v-btn>
							<v-spacer></v-spacer>
							<v-btn :disabled="!valid" depressed rounded class="salle-save-btn" @click="save">Enregistrer</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>

			<v-divider></v-divider>

			<!-- Venue cards -->
			<div v-if="loading" class="salle-loading">
				<v-progress-circular indeterminate size="32" color="#c62828"></v-progress-circular>
			</div>

			<div v-else-if="venues.length === 0" class="salle-empty">
				<v-icon size="48" color="#e5e7eb">mdi-domain-off</v-icon>
				<p class="salle-empty-text">Aucune salle configurée</p>
				<p class="salle-empty-sub">Créez votre première salle pour démarrer.</p>
			</div>

			<div v-else class="salle-grid pa-5">
				<div
					v-for="venue in venues"
					:key="venue._id"
					class="salle-card"
					:class="{ 'salle-card-active': currentVenueId === venue._id }"
				>
					<div class="salle-card-top">
						<div class="salle-card-icon">
							<v-icon size="22" color="white">mdi-domain</v-icon>
						</div>
						<div class="salle-card-badge" v-if="currentVenueId === venue._id">
							<v-chip small color="#d1fae5" text-color="#065f46">
								<v-icon left x-small>mdi-check-circle</v-icon>
								Active
							</v-chip>
						</div>
					</div>
					<p class="salle-card-name">{{ venue.name }}</p>
					<p class="salle-card-addr">
						<v-icon size="13" color="#9ca3af" class="mr-1">mdi-map-marker</v-icon>
						{{ venue.address }}
					</p>
					<p v-if="venue.phone" class="salle-card-phone">
						<v-icon size="13" color="#9ca3af" class="mr-1">mdi-phone</v-icon>
						{{ venue.phone }}
					</p>
					<div v-if="isAdmin" class="salle-card-actions">
						<v-btn icon small @click="editVenue(venue)">
							<v-icon size="17" color="#374151">mdi-pencil</v-icon>
						</v-btn>
					</div>
				</div>
			</div>
		</v-card>

		<!-- Delete dialog -->
		<v-dialog v-model="dialogDelete" max-width="440px">
			<v-card rounded="xl" class="pa-2">
				<div class="del-header">
					<div class="del-icon"><v-icon size="18" color="white">mdi-alert</v-icon></div>
					<div>
						<p class="del-title">Supprimer cette salle ?</p>
						<p class="del-sub">{{ venueToDelete ? venueToDelete.name : '' }}</p>
					</div>
				</div>
				<v-card-text class="pb-0">
					<p class="del-warn">Toutes les données associées à cette salle seront définitivement perdues.</p>
				</v-card-text>
				<v-card-actions class="pa-4 pt-2">
					<v-btn text color="grey" rounded @click="dialogDelete = false">Annuler</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed rounded class="del-confirm-btn" @click="deleteVenue">Supprimer</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import Loader from "@/components/Loader.vue";
import FloatingAlert from "@/components/FloatingAlert.vue";
import service from "../services";
export default {
	components: { Loader, FloatingAlert },
	data: () => ({
		loaderDialog: false,
		alertMessage: "",
		alertShow: false,
		alertType: "",
		dialog: false,
		dialogDelete: false,
		valid: false,
		loading: false,
		venues: [],
		venueToDelete: null,
		editedId: null,
		form: { name: "", address: "", phone: "" },
		defaultForm: { name: "", address: "", phone: "" },
	}),
	computed: {
		formTitle() { return this.editedId ? "Modifier la salle" : "Nouvelle salle"; },
		currentVenueId() { return this.$store.getters.currentVenueId; },
		isAdmin() { return this.$store.getters.userRole === 'ADMIN'; },
	},
	created() { this.loadVenues(); },
	watch: {
		dialog(val) { val || this.closeDialog(); },
	},
	methods: {
		loadVenues() {
			this.loading = true;
			service.getVenues()
				.then((r) => {
					this.venues = r.data?.salles || [];
					this.$store.dispatch('setVenues', this.venues);
					this.loading = false;
				})
				.catch((e) => { console.log(e); this.loading = false; });
		},
		manageAlert(show, type, msg) { this.alertShow = show; this.alertType = type; this.alertMessage = msg; },
		activateVenue(venue) {
			this.$store.dispatch('selectVenue', venue);
			this.manageAlert(true, "success", `Salle « ${venue.name} » activée`);
		},
		editVenue(venue) {
			this.editedId = venue._id;
			this.form = { name: venue.name, address: venue.address, phone: venue.phone || "" };
			this.dialog = true;
		},
		confirmDelete(venue) {
			this.venueToDelete = venue;
			this.dialogDelete = true;
		},
		deleteVenue() {
			this.loaderDialog = true;
			service.deleteVenue(this.venueToDelete._id)
				.then(() => {
					this.loaderDialog = false;
					this.dialogDelete = false;
					if (this.currentVenueId === this.venueToDelete._id) {
						this.$store.dispatch('selectVenue', null);
					}
					this.venueToDelete = null;
					this.loadVenues();
					this.manageAlert(true, "success", "Salle supprimée");
				})
				.catch((e) => { this.loaderDialog = false; this.manageAlert(true, "error", e?.message || "Erreur"); });
		},
		closeDialog() {
			this.dialog = false;
			this.$nextTick(() => { this.form = Object.assign({}, this.defaultForm); this.editedId = null; if (this.$refs.form) this.$refs.form.resetValidation(); });
		},
		save() {
			if (!this.$refs.form.validate()) return;
			this.loaderDialog = true;
			const p = this.editedId
				? service.updateVenue(this.editedId, this.form)
				: service.createVenue(this.form);
			p.then((r) => {
				this.loaderDialog = false;
				this.manageAlert(true, "success", "Salle enregistrée !");
				// If first venue created, auto-activate it
				if (!this.editedId && !this.currentVenueId) {
					const newVenue = r.data?.venue || r.data || { ...this.form, _id: null };
					if (newVenue._id) this.$store.dispatch('selectVenue', newVenue);
				}
				this.closeDialog();
				this.loadVenues();
			}).catch((e) => { this.loaderDialog = false; this.manageAlert(true, "error", e?.message || "Erreur"); });
		},
	},
};
</script>

<style scoped>
.salle-header { display: flex; align-items: center; padding: 18px 20px 14px; gap: 14px; flex-wrap: wrap; }
.salle-header-left { display: flex; align-items: center; gap: 14px; }
.salle-icon-box { width: 38px; height: 38px; border-radius: 10px; background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.salle-title { font-size: 0.92rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.salle-subtitle { font-size: 0.72rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.salle-add-btn { background: #c62828 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; box-shadow: 0 4px 12px rgba(198,40,40,0.28) !important; letter-spacing: 0.3px; }
/* Loading & empty */
.salle-loading { display: flex; justify-content: center; padding: 60px; }
.salle-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 60px 20px; text-align: center; }
.salle-empty-text { font-size: 1rem; font-weight: 700; color: #6b7280; margin: 0; font-family: Montserrat, sans-serif; }
.salle-empty-sub { font-size: 0.78rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
/* Grid */
.salle-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 16px; }
.salle-card { background: #f9fafb; border: 1.5px solid #e5e7eb; border-radius: 16px; padding: 20px; transition: all 0.2s; font-family: Montserrat, sans-serif; }
.salle-card:hover { border-color: #d1d5db; box-shadow: 0 4px 14px rgba(0,0,0,0.07); }
.salle-card-active { border-color: #c62828; background: #fff0f0; box-shadow: 0 0 0 3px rgba(198,40,40,0.08); }
.salle-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.salle-card-icon { width: 44px; height: 44px; border-radius: 12px; background: linear-gradient(135deg, #c62828, #1565c0); display: flex; align-items: center; justify-content: center; }
.salle-card-name { font-size: 1rem; font-weight: 800; color: #111827; margin: 0 0 6px; }
.salle-card-addr, .salle-card-phone { font-size: 0.75rem; color: #6b7280; margin: 0 0 4px; display: flex; align-items: center; }
.salle-card-actions { display: flex; align-items: center; margin-top: 16px; padding-top: 14px; border-top: 1px solid #e5e7eb; }
.salle-select-btn { background: #111827 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.75rem; }
/* Form dialog */
.form-dialog-header { display: flex; align-items: center; gap: 14px; padding: 18px 20px 14px; }
.form-dialog-icon { width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.form-dialog-title { font-size: 0.88rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.form-dialog-sub { font-size: 0.68rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.salle-save-btn { background: #c62828 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; box-shadow: 0 4px 12px rgba(198,40,40,0.28) !important; letter-spacing: 0.3px; }
/* Delete */
.del-header { display: flex; align-items: center; gap: 12px; padding: 16px 20px 12px; }
.del-icon { width: 34px; height: 34px; border-radius: 8px; background: #c62828; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.del-title { font-size: 0.9rem; font-weight: 700; color: #111827; margin: 0 0 2px; font-family: Montserrat, sans-serif; }
.del-sub { font-size: 0.72rem; color: #9ca3af; margin: 0; font-family: Montserrat, sans-serif; }
.del-warn { font-size: 0.78rem; color: #6b7280; font-family: Montserrat, sans-serif; background: #fef2f2; border: 1px solid #fee2e2; border-radius: 8px; padding: 10px 12px; margin: 0; }
.del-confirm-btn { background: #b91c1c !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; box-shadow: 0 3px 10px rgba(185,28,28,0.3) !important; }
</style>
